// Quelles requêtes vers l'API déclenchent l'animation de chargement de la zone principale ?
// Seules celles parties juste après un geste de l'utilisateur (clic, Entrée, changement de page), et pas les
// requêtes de fond (notifications, liste de tous les clients pour les menus, téléphonie…) qui ne doivent pas voiler la page.
const DELAI_APRES_GESTE = 1000;
const REQUETES_DE_FOND = /\/api\/(users\/all|notifications|telephonie|songs|spoolers|details)\b/;

let dernierGeste = 0;
let numeroGeste = 0;

function noterGeste() {
    dernierGeste = Date.now();
    numeroGeste++;
}

window.addEventListener("click", noterGeste, true);
window.addEventListener("hashchange", noterGeste);
window.addEventListener("keydown", e => {
    if (e.key === "Enter") noterGeste();
}, true);

/** Le numéro du geste qui a lancé cette requête, ou null si elle ne doit pas animer le chargement. */
export function gestePourRequete(config) {
    if (Date.now() - dernierGeste >= DELAI_APRES_GESTE) return null;
    if (REQUETES_DE_FOND.test(config.url || "")) return null;
    return numeroGeste;
}
